import moment from 'moment'
import { Calendar } from 'primereact/calendar'
import React, { useEffect, useState, lazy, Suspense } from 'react'
import { Alert } from '../../../common/Alert'
import { Dropdown } from 'primereact/dropdown'
import { AUTOCOMPLETE_TYPE, BOOKING_STATUS,FORM_FIELDS } from '../../../constants'
import { PRODUCT_PLACEHOLDER } from '../../../constants/Placeholders'
import SessionKeys from '../../../constants/sessionKeys'
import { getProducts } from '../../../services/manageBookingService'
import { getAirportsByCode } from '../../../services/searchPanelServices'
import getCurrentUser from '../../../utils/getCurrentUser'
import {
	clearItemFromSessionStorage,
	getBase64Decoded,
	getBase64Encoded,
	getFromSessionStorage,
	setToSessionStorage,
} from '../../../utils/StorageUtils'
import { padLeadingZeros } from '../../../utils/Validations'
import AirportAutocomplete from '../../AirportAutocomplete'
import ProductAutocomplete from '../../ShippingItemAutocomplete/ProductAutoComplete'
import BookingDetailsList from '../BookingDetailsList/BookingDetailsList'
import './list-booking.scss'
import {
	allowAlphaOnly,
	allowNumricOnly,
	formatInputTypeNumber,
	hasError,
	removeError,
	restrictSpaceSpecial,
	validateAWB,
	validateAwbPrefixRequired,
	validateCarrierCodeRequired,
	validateFlightNoRegex,
} from './ListbookingValidations'
import { useTranslation } from 'react-i18next'
import { addError, pushPageData,pushEventBookingSearch } from '../../../utils/analytics'

import pageNames from '../../../constants/pageNames'
import { PAGE_PRIMARY_CATEGORY, PAGE_SUB_CATEGORY1, BOOKING_PAGE_SUB_CATEGORY2 } from '../../../constants'
import BookingListMain from '../BookingDetailsList/BookingListMobileMain'
import LoadingIndicator from '../../LoadingIndicator'
import AppCalendar from '../../../common/Calendar'
import CommonInput from '../../../common/Resusable/CommonInput'
import upArrow from '../../../assets/images/chevron-up.png'
import upIcon from "../../../assets/images/chevronUp.svg";
import downIcon from "../../../assets/images/chevronDown.svg";
import { CommonDropDown } from '../../../common/Resusable/CommonDropDown'

const ListBooking = ({
	listBookingResponse,
	listBookingError,
	getBookingDetails,
	retainFormData,
	gsaAgentDetails
}) => {
	const { t, i18n } = useTranslation(['labels', 'errors'])
	const { agentDetails } = gsaAgentDetails

	const [selectedOrigin, setSelectedOrigin] = useState(null)
	const [selectedDestination, setSelectedDestination] = useState(null)

	const [advancedSearch, setAdvancedSearch] = useState(false)
	const [products, setProducts] = useState([])
	const [selectedProduct, setSelectedProduct] = useState(null)

	const [error, setError] = useState(null)

	const [notificationType, setNotificationType] = useState(null)
	const [notificationMessage, setNotificationMessage] = useState('')

	const [isLoading, setIsLoading] = useState(false)
	const [boookingFromfocused, setBookingFromFocused] = useState(false);
	const [bookingTofocused, setBookingToFocused] = useState(false);
	const [awbfocused, setAwbFocused] = useState(false);
	const [flightNumberFocused, setFlightNumberFocused] = useState(false);
	const [flightDateFocused, setFlightDateFocused] = useState(false);
	
	const ALL_STATUS_VALUE = 'ALL';

	

	const initialState = {
		origin: selectedOrigin,
		destination: selectedDestination,
		fromBookingDate: moment(
			new Date().setDate(new Date().getDate() - 14)
		).toDate(),
		toBookingDate: new Date(),
		shipmentIdentifierDetails: {
			shipmentPrefix: '607',
			masterDocumentNumber: '',
		},
		bookingStatus: ALL_STATUS_VALUE,
		product: null,
		commodity: null,
		carrierCode: 'EY',
		flightNumber: '',
		flightDate: null,
	}

	const [initialSearch, setInitialSearch] = useState(null)
	const initialPageNumber = 1
	const [bookingSearchFormData, setBookingSearchFormData] =
		useState(initialState)
	const [defaultorigin, setDefaultOrigin] = useState(null)

	const [customWidth, setcustomWidth] = useState(window.innerWidth)

	const updateDimensions = () => {
		setcustomWidth(window.innerWidth)
	}
	const[data,setData]=useState()
	

	useEffect(() => {
		window.addEventListener('resize', updateDimensions)
		return () => window.removeEventListener('resize', updateDimensions)
	}, [])

	useEffect(() => {
		if (!selectedOrigin) {
			const userDetails = getCurrentUser()
			let defaultAirport = userDetails && userDetails.defaultAirportCode ?  userDetails.defaultAirportCode : userDetails?.stationCode
			if(agentDetails?.agentDefaultAirportCode){
				// defaultAirport = agentDetails?.agentStationCode
				defaultAirport = agentDetails && agentDetails.agentDefaultAirportCode ? agentDetails.agentDefaultAirportCode : agentDetails.agentStationCode;
			}
			if (userDetails && defaultAirport) {
				getAirportsByCode(defaultAirport)
					.then((defaultOrigin) => {
						if (
							!getFromSessionStorage(SessionKeys.MANAGE_BOOKING_SEARCH_INFO)
						) {
							setIsLoading(true)
							getBookingDetails(
								getBookingPayload(bookingSearchFormData),
								// bookingSearchFormData,
								initialPageNumber,
								defaultOrigin
							)
							setSelectedOrigin(defaultOrigin)
							}
					})
					.catch((error) => console.log(error))
					addError('LOADING_ERROR', error) 
					}
		}

		;(async () => {
			try {
				const productList = await getProducts()
				const allOption = {
					name: 'All',
				}
				productList.unshift(allOption)
				if (productList) {
					setProducts(productList)
				}
				setSelectedProduct(allOption)
				pushPageData(
					pageNames.LIST_BOOKING,
					PAGE_PRIMARY_CATEGORY.E_SERVICES,
					PAGE_SUB_CATEGORY1.BOOKING,
					BOOKING_PAGE_SUB_CATEGORY2.MY_BOOKINGS
				)
			} catch (error) {
				console.log(error.message)
				addError('LOADING_PRODUCT_ERROR', error) 
				pushPageData(
					pageNames.LIST_BOOKING,
					PAGE_PRIMARY_CATEGORY.E_SERVICES,
					PAGE_SUB_CATEGORY1.BOOKING,
					BOOKING_PAGE_SUB_CATEGORY2.MY_BOOKINGS
				)
			}
		})()
	}, [])
	

	useEffect(() => {
		if (agentDetails?.agentStationCode) {
			getAirportsByCode(agentDetails.agentStationCode)
				.then((defaultOrigin) => {
					if (
						!getFromSessionStorage(SessionKeys.MANAGE_BOOKING_SEARCH_INFO)
					) {
						setIsLoading(true)
						getBookingDetails(
							getBookingPayload(bookingSearchFormData),
							// bookingSearchFormData,
							initialPageNumber,
							defaultOrigin
						)
						setSelectedOrigin(defaultOrigin)
					}
				})
				.catch((error) => console.log(error))
			addError('LOADING_ERROR', error)
		}
	}, [agentDetails])



	useEffect(() => {
		setBookingSearchFormData({
			...bookingSearchFormData,
			origin: selectedOrigin,
		})
	}, [selectedOrigin])

	useEffect(() => {
		setBookingSearchFormData({
			...bookingSearchFormData,
			product: selectedProduct,
		})
	}, [selectedProduct])

	useEffect(() => {
		setBookingSearchFormData({
			...bookingSearchFormData,
			destination: selectedDestination,
		})
	}, [selectedDestination])

	useEffect(() => {
		if (listBookingResponse || listBookingError) {
			setIsLoading(false)
		}
	}, [listBookingResponse, listBookingError])
	const clearError = () => {}

	useEffect(() => {
		if (retainFormData !== null) {
			const encodedBookingSearchForm = getFromSessionStorage(
				SessionKeys.MANAGE_BOOKING_SEARCH_INFO
			)
			if (
				retainFormData &&
				encodedBookingSearchForm &&
				encodedBookingSearchForm !== 'null'
			) {
				const bookingSearchData = getBase64Decoded(encodedBookingSearchForm)
				setBookingSearchFormData(bookingSearchData)
				setSelectedOrigin(bookingSearchData.origin)
				setSelectedDestination(bookingSearchData.destination)
				setSelectedProduct(bookingSearchData.product)
				setIsLoading(true)
				getBookingDetails(bookingSearchData, initialPageNumber, null)
				if (
					(bookingSearchData.product &&
						bookingSearchData.product.name !== 'All') ||
					bookingSearchData.flightDate !== null ||
					bookingSearchData.flightNumber !== '' ||
					(bookingSearchData.shipmentIdentifierDetails !== null &&
						bookingSearchData.shipmentIdentifierDetails.masterDocumentNumber !==
							'')
				) {
					setAdvancedSearch(true)
				}
			} else {
				//console.log("clearing session storage details file : listbooking");
				 //clearItemFromSessionStorage(SessionKeys.MANAGE_BOOKING_SEARCH_INFO)
				setBookingSearchFormData(initialState)
				setSelectedOrigin(bookingSearchFormData.origin)
				setSelectedDestination(bookingSearchFormData.destination)
				setSelectedProduct(bookingSearchFormData.product)
			}
		}
	}, [retainFormData])

	const handleChangeOfAWB = (value) => {
		if (value.length <= 12) {
			setBookingSearchFormData({
				...bookingSearchFormData,
				shipmentIdentifierDetails: {
					...bookingSearchFormData.shipmentIdentifierDetails,
					masterDocumentNumber: value,
				},
			})
			//validateAWB(value, setError, 'awbNumber')
		}
	}

	const validateFlightNo = (flightNo) => {
		let newFlightNumber = flightNo
		if (flightNo) {
			if (flightNo.length < 4) {
				newFlightNumber = padLeadingZeros(flightNo, 4)
				setBookingSearchFormData({
					...bookingSearchFormData,
					flightNumber: newFlightNumber,
				})
			}
			return validateFlightNoRegex(
				newFlightNumber,
				bookingSearchFormData.carrierCode,
				setError
			)
		} else {
			return true
		}
	}

	const handleChangeOfFlightNo = (flightNo) => {
		if (flightNo.length <= 5) {
			setBookingSearchFormData({
				...bookingSearchFormData,
				flightNumber: flightNo,
			})
		}
	}

	const getBookingPayload = (formData) => ({
        ...formData,
        bookingStatus: formData.bookingStatus === ALL_STATUS_VALUE ? null : formData.bookingStatus
    });

	const handleSubmit = (event) => {
		event.preventDefault()

		const isAwbValid = validateAWB(
			bookingSearchFormData.shipmentIdentifierDetails.masterDocumentNumber,
			setError,
			'awbNumber'
		)
		const isAwbPrefixValid = validateAwbPrefixRequired(
			bookingSearchFormData.shipmentIdentifierDetails.masterDocumentNumber,
			bookingSearchFormData.shipmentIdentifierDetails.shipmentPrefix,
			setError,
			'awbPrefix'
		)
		const isFlightNumberValid = validateFlightNo(
			bookingSearchFormData.flightNumber
		)

		const isCarrierCodeValid = validateCarrierCodeRequired(
			bookingSearchFormData.flightNumber,
			bookingSearchFormData.carrierCode,
			setError,
			'carrierCode'
		)
		if (
			isAwbValid &&
			isAwbPrefixValid &&
			isFlightNumberValid &&
			isCarrierCodeValid
		) {
			//console.log("set session storage from listbooking page");
			setToSessionStorage(
				SessionKeys.MANAGE_BOOKING_SEARCH_INFO,
				getBase64Encoded(bookingSearchFormData)
			)
			setIsLoading(true)
			getBookingDetails(getBookingPayload(bookingSearchFormData), initialPageNumber, null);
			// getBookingDetails(bookingSearchFormData, initialPageNumber, null)
			setInitialSearch(true)
			pushEventBookingSearch(data)
		}
	}

	const getPaginatedBookingResults = (currentPageNumber) => {
		if (initialSearch !== null) {
			setIsLoading(true)
			getBookingDetails(getBookingPayload(bookingSearchFormData), currentPageNumber, null);
			// getBookingDetails(bookingSearchFormData, currentPageNumber, null)
		}
	}
	// const changeBookingStatius = (value) => {
	// 	if (value === t('COMMON.ALL')) {
	// 		setBookingSearchFormData({
	// 			...bookingSearchFormData,
	// 			bookingStatus: null,
	// 		})
	// 	} else {
	// 		setBookingSearchFormData({
	// 			...bookingSearchFormData,
	// 			bookingStatus: value,
	// 		})
	// 	}
	// }

	const changeBookingStatius = (value) => {
        setBookingSearchFormData({
            ...bookingSearchFormData,
            bookingStatus: value,
        });
    };
	// console.log(bookingSearchFormData,"bookingSearchFormData")

	const handleSetError = (key, text) => {
		error
			? setError({
					...error,
					[key]: text,
			  })
			: setError({
					[key]: text,
			  })
	}

	const handleAlertClose = () => {
		setNotificationMessage('')
		setNotificationType(null)
	}

	const draftCallback = () => {}

	// const hasValue = bookingSearchFormData.shipmentIdentifierDetails.masterDocumentNumber?.toString().trim().length > 0;
	const hasValueOrError = !!bookingSearchFormData.shipmentIdentifierDetails.masterDocumentNumber?.toString().trim().length || !!error?.awbNumber;

	return (
		<div>
			{notificationMessage && notificationMessage !== '' && (
				<div className='pb-2'>
					<Alert
						showAlert={true}
						message={t(notificationMessage, { ns: 'errors' })}
						setTimeout={true}
						timeout={12000}
						onAlertClose={handleAlertClose}
						type={notificationType}
					/>
				</div>
			)}
			{isLoading ? <LoadingIndicator /> : <></>}
			<div className='listBooking-main'>
			<h3 className='listBooking-head mt-0'> {t('BOOKING.FIND_BOOKING')}</h3>
				<div className='listBookingForm' id='list-booking'>
					<div id='basicSearch' className='booking-input-section'>
						<div className='input-row'>
							<div
								className={`form-group common-autocomplete ${error && error[FORM_FIELDS.ORIGIN] ? "red-border" : ""
									}`}
							>
								<div className="p-float-label input-wrapper">
									<AirportAutocomplete
										autoCompleteType={AUTOCOMPLETE_TYPE.ORIGIN}
										selectedOrigin={selectedOrigin}
										selectedDestination={selectedDestination}
										setSelectedOrigin={setSelectedOrigin}
										handleSetError={handleSetError}
										clearError={clearError}
										screen='MANAGE_BOOKING'
										draftCallback={draftCallback}
										setNotificationMessage={setNotificationMessage}
										setNotificationType={setNotificationType}
									/>
									<label htmlFor="origin-airport">
										{t("COMMON.SHP_FROM")}
									</label>
								</div>
							</div>

							<div
								className={`form-group common-autocomplete ${error && error[FORM_FIELDS.DESTINATION]
									? "red-border"
									: ""
									}`}
							>
								<div className="p-float-label input-wrapper">
									{/* <label className="f-15">{t("COMMON.SHP_TO")}</label> */}
									<AirportAutocomplete
										autoCompleteType={AUTOCOMPLETE_TYPE.DESTINATION}
										selectedOrigin={selectedOrigin}
										selectedDestination={selectedDestination}
										setSelectedDestination={setSelectedDestination}
										handleSetError={handleSetError}
										clearError={clearError}
										screen='MANAGE_BOOKING'
										draftCallback={draftCallback}
										setNotificationMessage={setNotificationMessage}
										setNotificationType={setNotificationType}
									/>
									<label htmlFor="destination-airport">
										{t("COMMON.SHP_TO")}
									</label>
								</div>
								{/* <span className="search-panel__errormsg">
									{error && error[FORM_FIELDS.DESTINATION]
										? t(error[FORM_FIELDS.DESTINATION], { ns: "errors" })
										: ""}
								</span> */}
							</div>
						</div>
						<div className='input-row'>
							<div className='form-group'>

								{/* <label className='form-item__label'>
									{t('BKGLIST.BKG_CREATION_FRM')}
								  </label> */}

								<div className={`p-float-label ${boookingFromfocused ? 'custom-float-label' : ''}`}>
									<Calendar
										className="form-item__field"
										dateFormat="dd M yy"
										value={bookingSearchFormData.fromBookingDate ? moment(bookingSearchFormData.fromBookingDate).toDate() : null}
										maxDate={moment().toDate()}
										onChange={(e) => {
											setBookingSearchFormData({
												...bookingSearchFormData,
												fromBookingDate: e.value,
											});
										}}
										showOtherMonths={false}
										inputId="fromBookingDate"
										onFocus={() => setBookingFromFocused(true)}
										onBlur={() => setBookingFromFocused(false)}
									//   placeholder="select the date"  // You can keep or remove placeholder; but floating label and placeholder may conflict visually
									/>
									<label htmlFor="fromBookingDate">{t('BKGLIST.BKG_CREATION_FRM')}</label>
								</div>

							</div>

							<div className='form-group'>
								{/* <label className='form-item__label'>
									{t('BKGLIST.BKG_CREATION_TO')}
								</label> */}
								<div className={`p-float-label ${bookingTofocused ? 'custom-float-label' : ''}`}>
									<Calendar
										dateFormat='dd M yy'
										className="form-item__field"
										value={bookingSearchFormData.toBookingDate ? moment(bookingSearchFormData.toBookingDate).toDate() : null}
										minDate={moment(bookingSearchFormData.fromBookingDate).toDate()}
										maxDate={moment().toDate()}
										onChange={(e) => {
											setBookingSearchFormData({
												...bookingSearchFormData,
												toBookingDate: e.target.value,
											})
										}}
										showOtherMonths={false}
										inputId="toBookingDate"
										onFocus={() => setBookingToFocused(true)}
										onBlur={() => setBookingToFocused(false)}
									/>
									<label htmlFor="toBookingDate">{t('BKGLIST.BKG_CREATION_TO')}</label>
								</div>
							</div>
						</div>

						<div className='input-row'>

							<CommonDropDown
								className={"booking-status-dropdown"}
								label={t('BKGLIST.BKG_STATUS')}
								value={bookingSearchFormData.bookingStatus}
								options={BOOKING_STATUS}
								onChange={(e) => {
									changeBookingStatius(e.target.value)
								}}
							/>
							 {/* <CommonDropDown
											className={"booking-status-dropdown"}
											value={bookingSearchFormData?.advancedSearch?.bookingStatus}
											options={SHIPMENT_STATUS}
											label={t("SHIPMENT_LIST.SHP_STATUS")}
											onChange={(e) => {
											  const { value } = e.target;
											  setBookingSearchFormData((prev) => ({
												...prev,
												advancedSearch: {
												  ...prev.advancedSearch,
												  bookingStatus: value,
												},
											  }));
											}}
										  /> */}
							{/* <div className=' form-group form-item mb-0'>
								<label className="booking-status-label pl-0">{t('BKGLIST.BKG_STATUS')}</label>
								<div className='portal-col pl-0'>
									<Dropdown
										className={"cust-normal-dropdown-status"}
										value={bookingSearchFormData.bookingStatus}
										options={BOOKING_STATUS}
										onChange={(e) => {
											changeBookingStatius(e.target.value)
										}}
									></Dropdown>
								</div>
							</div> */}
						</div>

						<div className='shipping-input-bottom'>
							{!advancedSearch ? (
								<>
									<div
										className="advanced-search-section"
										onClick={() => setAdvancedSearch(true)}
									>
										<span className="link-label">{`${t(
											"COMMON.ADV_SEARCH"
										)}`}</span>
										<img alt="upanddown-icon" src={downIcon} />
									</div>
									<button
										type="button"
										className="primary-button"
										onClick={handleSubmit}
									>
										{t("COMMON.SEARCH")}
									</button>
								</>
							) : (

								<div
									className="advanced-search-section justify-content-start"
									onClick={() => setAdvancedSearch(false)}
								>
									<span className="link-label">{`${t(
										"COMMON.ADV_SEARCH"
									)}`}</span>
									<img alt="upanddown-icon" src={upIcon} />
								</div>
							)}
						</div>

						{advancedSearch ? (
							<>
								{/* <div className='portal-col custom-margin-search mb-3'> */}
									{/* First portal-row: ProductAutocomplete and AWB Number */}
								<div className="input-row">
									<div className="form-group autocomplete-dropdown product-autocomplete">
										<div className="p-float-label input-wrapper">
											<ProductAutocomplete
												selectedProduct={selectedProduct}
												setSelectedProduct={setSelectedProduct}
												products={products}
											/>
											<label className='product-label'>{t("COMMON.PRD")}</label>
										</div>
									</div>


									<div className={`form-group awb-input-section`}>
										<CommonInput
											id="awbPrefix"
											name="awbPrefix"
											type="text"
											label='Prefix'
											// className="p-inputtext p-component border-0 awb-prefix"
											aria-invalid={hasError('awbPrefix', error)}
											maxLength="3"
											value={bookingSearchFormData.shipmentIdentifierDetails.shipmentPrefix}
											onKeyPress={(evt) => allowNumricOnly(evt)}
											onChange={(e) =>
												setBookingSearchFormData({
													...bookingSearchFormData,
													shipmentIdentifierDetails: {
														...bookingSearchFormData.shipmentIdentifierDetails,
														shipmentPrefix: e.target.value,
													},
												})
											}
											onFocus={(e) => removeError(e, setError)}
											error={
												error && error["awbNumber"]
													? t(error["awbNumber"], { ns: "errors" })
													: ""
											}
											wrapperClassName={`awb-prefix ${bookingSearchFormData?.shipmentIdentifierDetails
												?.masterDocumentNumber
												? "has-value"
												: ""
												}`}
										/>

										<CommonInput
											id="awbNumber"
											name="awbNumber"
											type="text"
											aria-invalid={hasError('awbNumber', error)}
											value={bookingSearchFormData.shipmentIdentifierDetails.masterDocumentNumber}
											onKeyDown={(evt) => formatInputTypeNumber(evt)}
											onChange={(e) => handleChangeOfAWB(e.target.value)}
											onFocus={(e) => {

												removeError(e, setError);
											}}
											onBlur={(e) => {

												validateAWB(e.target.value, setError, 'awbNumber');
											}}
											label={t('COMMON.AWB_NUMBER')}
											error={
												error && error["awbNumber"]
													? t(error["awbNumber"], { ns: "errors" })
													: ""
											}
											wrapperClassName={"awb-suffix"}
											isOnlyErrorBorder
										/>
									</div>

									{/* <div
										className={`form-group position-relative ${error?.awbPrefix || error?.awbNumber ? 'has-error' : ''}`}
										data-module="molecules/form-item/FormItem"
									>
										<div
											className={`d-flex align-items-end border-bottom ${error?.awbPrefix || error?.awbNumber ? 'border-danger' : 'border-normal'}`}
											style={{ gap: '0.5rem' }}
										>
											
											<input
												id="awbPrefix"
												name="awbPrefix"
												type="text"
												className="p-inputtext p-component border-0 awb-prefix"
												aria-invalid={hasError('awbPrefix', error)}
												maxLength="3"
												value={bookingSearchFormData.shipmentIdentifierDetails.shipmentPrefix}
												onKeyPress={(evt) => allowNumricOnly(evt)}
												onChange={(e) =>
													setBookingSearchFormData({
														...bookingSearchFormData,
														shipmentIdentifierDetails: {
															...bookingSearchFormData.shipmentIdentifierDetails,
															shipmentPrefix: e.target.value,
														},
													})
												}
												onFocus={(e) => removeError(e, setError)}
											/>

											
											<div className="separator" />

											
											<div className={`p-float-label flex-grow-1 ${hasValueOrError ? 'custom-float-label' : ''}`}>
												<CommonInput
													id="awbNumber"
													name="awbNumber"
													type="text"
													inputType={"number"}
													className="form-item__field awb-number-text p-component border-0 shadow-none"
													aria-invalid={hasError('awbNumber', error)}
													value={bookingSearchFormData.shipmentIdentifierDetails.masterDocumentNumber}
													onKeyDown={(evt) => formatInputTypeNumber(evt)}
													onChange={(e) => handleChangeOfAWB(e.target.value)}
													onFocus={(e) => {

														removeError(e, setError);
													}}
													onBlur={(e) => {

														validateAWB(e.target.value, setError, 'awbNumber');
													}}
													label={'AWB Number'}
												
												/>
											</div>
										</div>

					
										{(error?.awbPrefix || error?.awbNumber) && (
											<div className="form-item__error text-danger mt-1">
												{error?.awbPrefix
													? t(error['awbPrefix'], { ns: 'errors' })
													: error?.awbNumber
														? t(error['awbNumber'], { ns: 'errors' })
														: ''}
											</div>
										)}
									</div> */}
									
								</div>
								
								<div
									className="input-row"
								>

                                 <div className={`form-group awb-input-section flight-number-section`}>
										<CommonInput
											id='carrierCode'
												name='carrierCode'
												type='text'
												label={t("COMMON.CODE")}
												// className='form-item__field carrier-code-text textFiledCaps border-0 shadow-none'
												aria-invalid={hasError('carrierCode', error)}
												maxLength='2'
												value={bookingSearchFormData.carrierCode}
												onKeyPress={(envt) => allowAlphaOnly(envt)}
												onChange={(e) =>
													setBookingSearchFormData({
														...bookingSearchFormData,
														carrierCode: e.target.value,
													})
												}
												onBlur={(e) =>
													validateCarrierCodeRequired(
														bookingSearchFormData.flightNumber,
														e.target.value,
														setError,
														'carrierCode'
													)
												}
												onFocus={(e) => removeError(e, setError)}
											error={
												error && error["carrierCode"]
													? t(error["carrierCode"], { ns: "errors" })
													: ""
											}
											wrapperClassName={`awb-prefix ${bookingSearchFormData?.shipmentIdentifierDetails
												?.masterDocumentNumber
												? "has-value"
												: ""
												}`}
										/>

										<CommonInput
											id='flightNumber'
											name='flightNumber'
											type='text'
											aria-invalid={hasError('flightNumber', error)}
											value={bookingSearchFormData.flightNumber}
											onKeyPress={(e) => restrictSpaceSpecial(e)}
											onFocus={(e) => removeError(e, setError)}
											onChange={(e) => handleChangeOfFlightNo(e.target.value)}
											onBlur={(e) => validateFlightNo(e.target.value)}
											label={t('COMMON.FLT_NO')}
											error={
												error && error["flightNumber"]
													? t(error["flightNumber"], { ns: "errors" })
													: ""
											}
											wrapperClassName={"awb-suffix"}
											isOnlyErrorBorder
										/>
									</div>								
									
									{/* <div
										className={` form-group position-relative ${error?.carrierCode || error?.flightNumber ? 'has-error' : ''}`}
										data-module='molecules/form-item/FormItem'
									>
										<div
											className={`d-flex align-items-end border-bottom ${error?.carrierCode || error?.flightNumber ? 'border-danger' : 'border-normal-flight'}`}
											style={{ gap: '0.5rem' }}
										>
											
											<input
												id='carrierCode'
												name='carrierCode'
												type='text'
												className='form-item__field carrier-code-text textFiledCaps border-0 shadow-none w-25'
												aria-invalid={hasError('carrierCode', error)}
												maxLength='2'
												value={bookingSearchFormData.carrierCode}
												onKeyPress={(envt) => allowAlphaOnly(envt)}
												onChange={(e) =>
													setBookingSearchFormData({
														...bookingSearchFormData,
														carrierCode: e.target.value,
													})
												}
												onBlur={(e) =>
													validateCarrierCodeRequired(
														bookingSearchFormData.flightNumber,
														e.target.value,
														setError,
														'carrierCode'
													)
												}
												onFocus={(e) => removeError(e, setError)}
											/>

											
											<div className="separator" />

											
											<div className={`p-float-label flex-grow-1 ${bookingSearchFormData.flightNumber || error?.flightNumber ? 'custom-float-label' : ''}`}>
												<CommonInput
													id='flightNumber'
													name='flightNumber'
													type='text'
													className='form-item__field awb-number-text border-0 shadow-none'
													aria-invalid={hasError('flightNumber', error)}
													value={bookingSearchFormData.flightNumber}
													onKeyPress={(e) => restrictSpaceSpecial(e)}
													onFocus={(e) => removeError(e, setError)}
													onChange={(e) => handleChangeOfFlightNo(e.target.value)}
													onBlur={(e) => validateFlightNo(e.target.value)}
													label='Flight Number'
												/>
											</div>
										</div>

										
										{(error?.carrierCode || error?.flightNumber) && (
											<div className='form-item__error text-danger mt-1'>
												{error?.carrierCode
													? t(error['carrierCode'], { ns: 'errors' })
													: error?.flightNumber
														? t(error['flightNumber'], { ns: 'errors' })
														: ''}
											</div>
										)}
									</div> */}

									<div className="form-group">
										<CommonInput
											className='form-item__field flight-date'
											dateFormat='dd M yy'
											value={bookingSearchFormData.flightDate ? moment(bookingSearchFormData.flightDate).toDate() : null}
											onChange={(e) => {
												setBookingSearchFormData({
													...bookingSearchFormData,
													flightDate: e.target.value,
												})
											}}
											showOtherMonths={false}
											inputId="flightDate"
											onFocus={() => setFlightDateFocused(true)}
											onBlur={() => setFlightDateFocused(false)}
											type="calendar"
											label={t('COMMON.FLT_DATE')}
										/>
									</div>

									{/* <div className='portal-col calendar-group form-group flight-date-section pl-0' style={{ flex: 1, minWidth: 0 }}>
										<div className={`p-float-label ${flightDateFocused ? 'custom-float-label' : ''}`}>
											<Calendar
												className='form-item__field flight-date'
												dateFormat='dd M yy'
												value={bookingSearchFormData.flightDate ? moment(bookingSearchFormData.flightDate).toDate() : null}
												onChange={(e) => {
													setBookingSearchFormData({
														...bookingSearchFormData,
														flightDate: e.target.value,
													})
												}}
												showOtherMonths={false}
												inputId="flightDate"
												onFocus={() => setFlightDateFocused(true)}
												onBlur={() => setFlightDateFocused(false)}
											/>
											<label htmlFor="flightDate">{t('COMMON.FLT_DATE')}</label>
										</div>
									</div> */}
								</div>	
							</>
						) : (
							<></>
						)}

						{advancedSearch && (
							<div className='form-row mt-5 mt-md-4'>
								<div className='col-12 cta_wrap flex-column flex-lg-row text-right'>
									<button type='button' className='primary-button' onClick={handleSubmit}>
										{t('COMMON.SEARCH')}
									</button>
								</div>
							</div>
						)}
					</div>	
				</div>
			</div>
			{customWidth > 991 ? (
				<BookingDetailsList
					initialSearch={initialSearch}
					setInitialSearch={setInitialSearch}
					listBookingResponse={listBookingResponse}
					listBookingError={listBookingError}
					getPaginatedBookingResults={getPaginatedBookingResults}
					setNotificationMessage={setNotificationMessage}
					setNotificationType={setNotificationType}
				/>
			) : (
				<BookingListMain
					listBookingResponse={listBookingResponse}
					listBookingError={listBookingError}
					setNotificationMessage={setNotificationMessage}
					setNotificationType={setNotificationType}
					// bookingSearchFormData={bookingSearchFormData}
					bookingSearchFormData={getBookingPayload(bookingSearchFormData)}
					getBookingDetails={getBookingDetails}
					initialSearch={initialSearch}
					setInitialSearch={setInitialSearch}
					isLoading={isLoading}
					setIsLoading={setIsLoading}
				/>
			)}
		</div>
	)
}

export default ListBooking
